// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store/index'
import fastClick from 'fastClick'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Message from 'vue-m-message'
import VueSweetalert2 from 'vue-sweetalert2'

import '@/assets/css/reset.css'
import '@/assets/css/common.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'swiper/dist/css/swiper.css'

import {
  getUserInfo
} from '@/utils/user.js'

Vue.config.productionTip = false
fastClick.attach(document.body)
Vue.use(VueAwesomeSwiper)
Vue.use(Message)
Vue.use(VueSweetalert2)

router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});

var docTitle = document.title;
router.beforeEach((to, from, next) => {
  if(to.meta.title){
    document.title = to.meta.title;
  }else{
    document.title = docTitle;
  }
  if(to.meta.loginRequired){
    if(store.getters['user/getToken'] && store.getters['user/getUserInfo']){
      next();
    }else{
      
      next('/login');
      /*if(confirm('请先登录再访问。去登录？')){
        next('/login');
      }else{
        window.history.back(-1);
        return;
      }*/
    }
  }
  next();
})

router.afterEach(function(to,from){
  //实现菜单导航，获取当前页面在那个菜单下
  localStorage.setItem('currMenu', to.meta.menuIndex);
})

Vue.component('remote-script', {
  render: function (createElement) {
    var self = this;
    return createElement('script', {
      attrs: {
        type: 'text/javascript',
        src: this.src,
        charset: this.charset,
        id: this.id
      },
      on: {
        load: function (event) {
          self.$emit('load', event);
        },
        error: function (event) {
          self.$emit('error', event);
        },
        readystatechange: function (event) {
          if (this.readyState == 'complete') {
            self.$emit('load', event);
          }
        }
      }
    });
  },
  props: {
    src: {
      type: String,
      required: true
    }
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#AFCWAVE',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js